import React from 'react';
import LoginPage from './components/login_page';

import Dashboard from './components/dashboard'
import Home from './components/home'
import privacidad from './components/privacidad'
import condiciones from './components/condiciones'

import history from './history';
import { Route, Switch, Router } from "react-router-dom";
import './App.css';

function App() {
  return (
    <div className="App">
      <Router history={history}>
        <Switch>
          <Route exact path="/" component={LoginPage} />
          <Route exact path="/dashboard" component={Dashboard} />
          <Route exact path="/home" component={Home} />
          <Route exact path="/privacidad" component={privacidad} />
          <Route exact path="/condiciones" component={condiciones} />
 

        </Switch>
     </Router>
    </div>
  );
}

export default App;
